import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { CheckCircle2, Circle, AlertCircle, User } from "lucide-react";

const PRIORITY_COLORS = {
  high: "bg-red-100 text-red-700 border-red-200",
  medium: "bg-amber-100 text-amber-700 border-amber-200",
  low: "bg-blue-100 text-blue-700 border-blue-200",
};

export default function ActionItemsList({ actionItems = [], onUpdateStatus }) {
  const pending = actionItems.filter((a) => a.status === "pending");
  const done = actionItems.filter((a) => a.status === "done");

  return (
    <div className="bg-white rounded-lg border border-slate-200 shadow-sm">
      <div className="flex items-center gap-2 px-4 py-3 border-b border-slate-100 bg-gradient-to-r from-blue-50 to-white">
        <CheckCircle2 className="w-4 h-4 text-blue-500" />
        <h3 className="text-sm font-semibold text-slate-700">Action Items</h3>
        {actionItems.length > 0 && (
          <Badge variant="secondary" className="ml-auto text-[10px]">
            {actionItems.length}
          </Badge>
        )}
      </div>
      <ScrollArea className="h-48">
        {actionItems.length === 0 && (
          <div className="flex flex-col items-center justify-center h-32 text-slate-400">
            <CheckCircle2 className="w-6 h-6 mb-1 opacity-50" />
            <p className="text-xs">No action items yet</p>
          </div>
        )}
        <div className="p-3 space-y-2">
          {pending.map((item, i) => (
            <div key={i} className="flex items-start gap-2 p-2 rounded-lg bg-slate-50 border border-slate-100">
              <button onClick={() => onUpdateStatus?.(item, "done")} className="mt-0.5 shrink-0">
                <Circle className="w-4 h-4 text-slate-300 hover:text-green-500 transition-colors" />
              </button>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-slate-700">{item.description}</p>
                <div className="flex items-center gap-2 mt-1">
                  {item.priority && (
                    <Badge variant="outline" className={`text-[10px] ${PRIORITY_COLORS[item.priority] || PRIORITY_COLORS.medium}`}>
                      {item.priority}
                    </Badge>
                  )}
                  {item.assignee && item.assignee !== "unassigned" && (
                    <span className="flex items-center gap-1 text-[10px] text-slate-400">
                      <User className="w-3 h-3" />
                      {item.assignee}
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
          {done.length > 0 && (
            <>
              <div className="text-[10px] font-medium text-slate-400 uppercase tracking-wider pt-2 border-t border-slate-100">
                Completed ({done.length})
              </div>
              {done.map((item, i) => (
                <div key={i} className="flex items-start gap-2 p-2 rounded-lg opacity-60">
                  <CheckCircle2 className="w-4 h-4 text-green-500 mt-0.5 shrink-0" />
                  <p className="text-sm text-slate-500 line-through">{item.description}</p>
                </div>
              ))}
            </>
          )}
        </div>
      </ScrollArea>
    </div>
  );
}
